module.exports = __webpack_public_path__ + "static/media/book.4b24e7a4.png";